import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import ThemeSelector from './components/theme/ThemeSelector';

// Import your existing components
import Welcome from './components/welcome/Welcome';
import Contact from './components/contact/Contact';
import Dashboard from './components/dashboard/Dashboard';
import ProductClassification from './components/classification/ProductClassification';
import ProductCategoryOverview from './components/products/ProductCategoryOverview';
import ProductHierarchy from './components/products/ProductHierarchy';
import BrandAnalysis from './components/products/BrandAnalysis';
import GeoOverview from './components/geo/GeoOverview';
import WorldHeatMap from './components/geo/WorldHeatMap';
import RegionalComparison from './components/geo/RegionalComparison';
import ShopCategoryOverview from './components/shops/ShopCategoryOverview';
import ShopHierarchy from './components/shops/ShopHierarchy';
import ShopPerformance from './components/shops/ShopPerformance';
import TimeSeriesAnalysis from './components/time/TimeSeriesAnalysis';
import SeasonalTrends from './components/time/SeasonalTrends';
import YearOverYearComparison from './components/time/YearOverYearComparison';

// Import the example component
import BrandAnalysisExample from './components/sample/BrandAnalysisExample';

function AppContent() {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Router>
      <div className="app-container">
        {/* Sidebar - matching original layout */}
        <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
          <div className="sidebar-header">
            {!collapsed ? '' : ''}
          </div>
          
          {/* Main Section */}
          <div className="sidebar-section">
            <h3>MAIN</h3>
            <ul>
              <li>
                <NavLink 
                  to="/" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  👋 Welcome
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/contact" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  📞 Contact
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/dashboard" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🏠 Dashboard
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Products Section */}
          {/* Geography Section */}
          <div className="sidebar-section">
            <h3>GEOGRAPHY</h3>
            <ul>
              <li>
                <NavLink 
                  to="/geo/overview" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🌍 Geographic Overview
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/geo/heatmap" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🗺️ World Heat Map
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/geo/comparison" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  ⚖️ Regional Comparison
                </NavLink>
              </li>
            </ul>
          </div>


          <div className="sidebar-section">
            <h3>PRODUCTS</h3>
            <ul>
              <li>
                <NavLink 
                  to="/products/overview" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  📊 Category Overview
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/products/hierarchy" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🌳 Product Hierarchy
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/products/brands" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🏷️ Brand Analysis
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/classification" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🔖 Classification
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Retail Section */}
          <div className="sidebar-section">
            <h3>RETAIL</h3>
            <ul>
              <li>
                <NavLink 
                  to="/shops/overview" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🏪 Shop Categories
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/shops/hierarchy" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🏢 Shop Hierarchy
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/shops/performance" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  📈 Shop Performance
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Time Analysis Section */}
          <div className="sidebar-section">
            <h3>TIME ANALYSIS</h3>
            <ul>
              <li>
                <NavLink 
                  to="/time/series" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  📉 Time Series
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/time/seasonal" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  🔄 Seasonal Trends
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/time/comparison" 
                  className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                >
                  📅 Year over Year
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          {/* Header Bar */}
          <div className="header">
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <button 
                onClick={toggleSidebar} 
                className="btn btn-small"
                style={{ padding: '8px 12px' }}
              >
                {collapsed ? '→' : '←'}
              </button>
              <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                TIRITIX.COM
              </h1>
            </div>
            <ThemeSelector />
          </div>

          {/* Route Content */}
          <div style={{ padding: '0 20px 20px' }}>
            <Routes>
              <Route path="/" element={<Welcome />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/classification" element={<ProductClassification />} />
              
              {/* Product Routes */}
              <Route path="/products/overview" element={<ProductCategoryOverview />} />
              <Route path="/products/hierarchy" element={<ProductHierarchy />} />
              <Route path="/products/brands" element={<BrandAnalysis />} />
              
              {/* Add example route for testing */}
              <Route path="/example/brand-analysis" element={<BrandAnalysisExample />} />
              
              {/* Geographic Routes */}
              <Route path="/geo/overview" element={<GeoOverview />} />
              <Route path="/geo/heatmap" element={<WorldHeatMap />} />
              <Route path="/geo/comparison" element={<RegionalComparison />} />
              
              {/* Shop Routes */}
              <Route path="/shops/overview" element={<ShopCategoryOverview />} />
              <Route path="/shops/hierarchy" element={<ShopHierarchy />} />
              <Route path="/shops/performance" element={<ShopPerformance />} />
              
              {/* Time Analysis Routes */}
              <Route path="/time/series" element={<TimeSeriesAnalysis />} />
              <Route path="/time/seasonal" element={<SeasonalTrends />} />
              <Route path="/time/comparison" element={<YearOverYearComparison />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
